import { useEffect } from "react";
import useCookie from "../../hooks/useCookie";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";

export default function useViewController() {
  const { getCookie } = useCookie();
  const { openModal } = useModalActions();

  useEffect(() => {
    const watchFirstTimeGameModalValue = getCookie("isWatchFirstTimeGameModal");

    if (+watchFirstTimeGameModalValue === 1) {
      openModal(MODAL_TYPES.FIRST_TIME_PLAYING);
    }
  }, []);
}
